import React, { useEffect } from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import { navigateHook } from "../../../../../hooks/use-navigate.js";
import { encounterStatusLabel } from "../../../../../utils/enums/encounter-status-enum.js";

const ReportContent = ({data, tableColumns}) => {
    const navigate = navigateHook();
    const rows = data ?? [];

    const getGarrison = (element) => ({
        garrison: element.garrison_name ?? "",
        team: element.garrison_team ?? "",
        contingents: element.contingent_namewar ?? ""
    });

    const columns = [
        {
            id: "id",
            sortField: "id",
            className: "w-[5%]",
            getValue: element => element.id,
            renderCell: element => <a onClick={() => navigate(`/encounter/form/${element.id}`, true)} className="report-link">{element.id}</a>
        },
        {id: "encounter_start", sortField: "encounter_start", className: "w-[13%]", getValue: element => element.encounter_start, renderCell: element => element.encounter_start},
        {id: "encounter_end", sortField: "encounter_end", className: "w-[13%]", getValue: element => element.encounter_end, renderCell: element => element.encounter_end},
        {id: "namewar", sortField: "namewar", className: "w-[20%]", getValue: element => element.namewar, renderCell: element => element.namewar},
        {id: "status", sortField: "status", className: "w-[10%]", getValue: element => encounterStatusLabel(element.status), renderCell: element => encounterStatusLabel(element.status)},
        {
            id: "garrison",
            exportGroup: "garrison",
            exportIgnore: true,
            sortField: "garrison_name",
            className: "w-[34%] print:hidden",
            getValue: element => element.garrison_name ?? "Não informado",
            renderCell: element => {
                const garrison = getGarrison(element);
                return garrison.garrison ? (
                    <div className="flex flex-col gap-1">
                        <span>{garrison.garrison}</span>
                        <span><strong>Equipe:</strong>{" "}<span className={!element.garrison_team ? "text-[#8F8F8F] italic" : ""}>{garrison.team || "Não informado"}</span></span>
                        {garrison.contingents && <span><strong>Contingentes:</strong>{" "}{garrison.contingents}</span>}
                    </div>
                ) : <span>Não informado</span>;
            }
        },
        {id: "garrison_name", label: "Guarnição", exportGroup: "garrison", sortField: "garrison_name", className: "w-[15%] hidden print:table-cell", getValue: element => getGarrison(element).garrison || "Não informado", renderCell: element => getGarrison(element).garrison || "Não informado"},
        {id: "garrison_team", exportGroup: "garrison", sortField: "garrison_team", className: "w-[10%] hidden print:table-cell", getValue: element => element.garrison_team ?? "Não informado", renderCell: element => element.garrison_team || "Não informado"},
        {id: "contingent_namewar", exportGroup: "garrison", sortField: "contingent_namewar", className: "w-[19%] hidden print:table-cell", getValue: element => element.contingent_namewar ?? "Não informado", renderCell: element => element.contingent_namewar || "Não informado"}
    ];

    const isExportOnly = (column) => tableColumns?.[column.id]?.exportOnly === true;
    const isExportIgnored = (column) => column.exportIgnore === true || tableColumns?.[column.id]?.exportIgnore === true;
    const isExportGroupVisible = (column) => !column.exportGroup || tableColumns?.[column.exportGroup]?.visible !== false;
    const visibleColumns = columns.filter(column => !isExportOnly(column) && tableColumns?.[column.id]?.visible !== false);
    const exportColumns = columns.filter(column => !isExportIgnored(column) && isExportGroupVisible(column) && (isExportOnly(column) || tableColumns?.[column.id]?.visible !== false));
    const printColumns = [...visibleColumns, ...columns.filter(column => isExportOnly(column) && isExportGroupVisible(column))];

    useEffect(() => {
        ReportUtils.withoutContentReadjust();
    }, [data]);

    useEffect(() => {
        const labels = exportColumns.map(column => tableColumns?.[column.id]?.label ?? column.label ?? column.id);
        const values = rows.map(element => exportColumns.map(column => column.getValue(element)));
        ReportUtils.createExportableTable(labels, values, "Lista de abordagens");
    }, [data, tableColumns]);

    return (
        <>
            {visibleColumns.length === 0 ? (
                <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>
            ) : (
                <table id="encounter-list-data" className="table report-table">
                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            {printColumns.map(column => <th key={column.id} className={`${column.className} ${isExportOnly(column) ? "hidden print:table-cell" : ""}`}>{tableColumns?.[column.id]?.label ?? column.label ?? column.id}</th>)}
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {rows.map((element, index) => (
                            <tr key={element.id ?? index} className="break-word print:break-inside-avoid">
                                {printColumns.map(column => <td key={column.id} className={`${column.className} ${isExportOnly(column) ? "hidden print:table-cell" : ""}`}>{column.renderCell(element)}</td>)}
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;